import { animate, AnimationTriggerMetadata, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';


const nothingVisible: { [property: string]: string | number } = {
  opacity: 0,
  height: '{{height}}',
};

const allVisible: { [property: string]: string | number } = {
  opacity: 1,
  height: '{{height}}',
};

export const appearAnimations: AnimationTriggerMetadata = trigger(
  'appearAnimation',
  [
    state('void', style(nothingVisible),{ params: { height: AUTO_STYLE } }),
    state('*', style(allVisible), { params: { height: AUTO_STYLE } }),
    transition('void => *', animate('200ms 100ms linear')),
    transition('* => void', animate('200ms 100ms linear')),
  ]);
